import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Button, Breadcrumb, Icon, Carousel, message } from 'antd'
import '../assets/css/assetTrust.css'
import ReactSVG from 'react-svg'
import service01 from '../assets/images/icons/01service.svg'
import service02 from '../assets/images/icons/02service.svg'
import search03 from '../assets/images/icons/03search.svg'
import trustService from '../assets/images/trustService.svg'
import fundService from '../assets/images/fundService.svg'
import hotline from '../assets/images/hotline.svg'
import onlineService from '../assets/images/onlineService.svg'
import email from '../assets/images/email.svg'
import wechat from '../assets/images/wechat.png'
import banner from '../assets/images/banner.jpg'
import { getBannerList, getServiceNews } from '../api'

class AssetTrust extends Component {
    constructor () {
        super()
        this.carousel = React.createRef()
        this.state = {
            bannerList: [],
            serviceNews: []
        }
    }
    // carousel方法
    handlePrev () {
        this.carousel && this.carousel.current.prev()
    }
    handleNext () {
        this.carousel && this.carousel.current.next()
    }
    // 编程式导航
    handleRouterTo (url) {
        this.props.history.push(url)
    }

    pageTo(hash) {
        // if(this.value = "0")
        window.location.href = `${window.location.origin}/gs/zctg/#/${hash}`
    }

    pageTos2(a) {
        window.location.href =`${a}`
    }

    // 获取轮播图列表
    getBannerList () {
        // 获取轮播图列表
        getBannerList().then(res => {
            if (res.data) {
                const bannerList = res.data.map(({id, thumbnail, title, url}) => {
                    return {
                        id,
                        thumbnail,
                        title,
                        url
                    }
                })
                this.setState({
                    bannerList
                })
           }
        })
    }

    // 获取业务动态
    getServiceNews () {
        getServiceNews({ pageNo: 1, pageSize: 9999 }).then(res => {
            if (res.data) {
                this.setState({
                    serviceNews: res.data
                })
            }
        }).catch(err => {
            message.error(err.msg)
        })
    }


    componentDidMount () {
        this.getBannerList()
        this.getServiceNews()
    }
    render () {
        return (
            <div>
                <div className="banner-asset">
                    <Carousel ref={ this.carousel } autoplay={true}>
                        {
                            this.state.bannerList.map(({ id, thumbnail, title, url}) => {
                                return (
                                    <div className="banner-item" key={id}>
                                        <a href={url}>
                                            <img src={ thumbnail || banner } title='' alt='' />
                                        </a>
                                    </div>
                                )
                            })
                        }
                    </Carousel>
                    <div className="banner-btns">
                        <Button value="0" onClick={() => this.pageTos2('https://fm88.guosen.com.cn/xgj/index')}><ReactSVG src={ service01 } wrapper="span"/>管理人服务平台</Button>
                        <Button value="0" onClick={() => this.pageTos2('https://tzzcx.guosen.com.cn/inv/view/login.html')}><ReactSVG src={ service02 } wrapper="span"/>投资者服务平台</Button>
                        <Button onClick={() => this.handleRouterTo('/raiseAccount')}><ReactSVG src={ search03 } wrapper="span"/>募集户核对</Button>
                    </div>
                    <div className="banner-arrow-wrap">
                        <div className="banner-arrow" onClick={() => this.handlePrev()}>
                            <Icon type="left" />
                        </div>
                        <div className="banner-arrow" onClick={ () => this.handleNext() }>
                            <Icon type="right" />
                        </div>
                    </div>
                </div>
                <div className="page-title l-container">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="page-content">
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务服务</h2>
                            <div className="service-intro">
                                <div className="intro-box">
                                    <div className="intro-box-click" onClick={() => this.pageTo('trustService')}>
                                        <img src={ trustService } alt="trustService"/>
                                        <h3>托管服务</h3>
                                    </div>
                                    <div className="info">
                                    资产托管服务是指我司依据法律法规的规定和合同协议的约定，作为独立第三方，为管理人依法发行的基金产品提供资产保管、清算交割、估值复核、投资监督、信息披露等专业的资产托管服务。
                                    </div>
                                    <div>
                                        <div className="ant-btn"><a href="http://www.csrc.gov.cn/pub/zjhpublic/G00306205/201509/t20150924_284313.htm">查看业务资格<Icon type="right" /></a></div>
                                    </div>
                                </div>
                                <div className="intro-box">
                                    <div className="intro-box-click" onClick={() => this.pageTo('fundService')}>
                                        <img src={ fundService } alt="fundService"/>
                                        <h3>基金服务</h3>
                                    </div>
                                    <div className="info">
                                    基金服务业务是指我司作为第三方机构，接受资产管理机构委托，为资产管理机构提供份额登记、估值核算等后台运营服务。
                                    </div>
                                    <div>
                                        <div className="ant-btn"><a href="http://fo.amac.org.cn/amac/allNotice.do">查看业务资格<Icon type="right" /></a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务优势</h2>
                            <div className="service-merit">
                                <div className="merit-box">
                                    <div className="merit-circle">
                                        <div className="merit-profession"></div>
                                    </div>
                                    <div>
                                        <h4>专业能力强</h4>
                                        <p>服务模式不断创新</p>
                                        <p>服务案例丰富</p>
                                    </div>
                                </div>
                                <div className="merit-box">
                                    <div className="merit-circle">
                                        <div className="merit-exprience"></div>
                                    </div>
                                    <div>
                                        <h4>服务经验丰富</h4>
                                        <p>累计服务管理人逾3000家</p>
                                        <p>服务基金产品数量超17000只</p>
                                        <p>拥有丰富的业务服务和运营经验</p>
                                    </div>
                                </div>
                                <div className="merit-box">
                                    <div className="merit-circle">
                                        <div className="merit-system"></div>
                                    </div>
                                    <div>
                                        <h4>服务体系完善</h4>
                                        <p>线上一站式综合运营服务</p>
                                        <p>线下提供多品类增值服务</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务动态</h2>
                            <div className="service-news">
                                <div className="scroll-wrap">
                                    <div className="scroll-inner">
                                        <ul>
                                            {
                                                this.state.serviceNews.map((item, index) => {
                                                return (
                                                        <li key={item.id}>
                                                            <a href={`/gs/business/info_detail.html?channelid=${item.channelid}&id=${item.id}`}>
                                                                <span>{`0${index + 1}`}</span>
                                                                <span>
                                                                    {item.title}
                                                                </span>
                                                            </a>
                                                        </li>
                                                )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                                <div className="public-wechat">
                                    <div>
                                        <div className="wechat-wrap">
                                            <img src={ wechat } alt="wechat"/>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div className="info">
                                            <p>扫描二维码</p>
                                            <p>关注国信证券托管与外包公众号</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>联系我们</h2>
                            <div className="concat-us">
                            
                                <div className="concat-box">
                                    <div className="concat-box-t">
                                        <h3>在线客服</h3>
                                        <div className="img-wrap"><img src={ onlineService } alt="onlineService"/></div>
                                    </div>
                                    <div className="concat-box-b">
                                        <p>请登录管理人服务平台点击右方“在线客服”按钮</p>
                                        {/* <p>联系我们</p> */}
                                    </div>
                                </div>
                                <div className="concat-box">
                                    <div className="concat-box-t">
                                        <h3>热线电话</h3>
                                        <div className="img-wrap"><img src={ hotline } alt="hotline"/></div>
                                    </div>
                                    <div className="concat-box-b">
                                        <p>0755-61897778</p>
                                    </div>
                                </div>
                                <div className="concat-box">
                                    <div className="concat-box-t">
                                        <h3>电子邮件</h3>
                                        <div className="img-wrap"><img src={ email } alt="email"/></div>
                                    </div>
                                    <div className="concat-box-b">
                                        <p>客服邮箱：</p>
                                        <p>03556@guosen.com.cn</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AssetTrust;
